import React from 'react';

window.ajaxFails = (jqXHR) => {
    if (jqXHR && jqXHR.statusText == 'abort') { return } // Cause by manual abort, no need show error
    let json = JSON.parse(jqXHR.responseText);
    if (json["message"] == "The given data was invalid." && json["errors"]) {
        // Example format of errors
        // "errors":{"email":["The email must be a valid email address."]}
        if (json["errors"]) {
            const firstKey = Object.keys(json["errors"])[0]
            alert(json["errors"][firstKey][0])
        }
    }
    else if (json["message"]) {
        alert(json["message"]);
    }
    else {
        alert(json[Object.keys(json)[0]]);
    }
}
window.getAjaxError = (jqXHR) => {
    if (jqXHR && jqXHR.statusText == 'abort') { return } // Cause by manual abort, no need show error

    try {
        let json = JSON.parse(jqXHR.responseText);
        let errorCode = json["error_code"] || json["error"] || json["code"]
        let message = ''
        if (json["errors"]) {
            // Example format of errors
            // "errors":{"email":["The email must be a valid email address."]}
            if (json["errors"]) {
                const firstKey = Object.keys(json["errors"])[0]
                message = json["errors"][firstKey][0]
            }
        }
        else if (json["message"]) {
            message = json["message"]
        }
        return { errorCode, message }
    }
    catch {

    }
}

export const getAjaxError = (jqXHR) => {
    if (jqXHR && jqXHR.statusText == 'abort') { return } // Cause by manual abort, no need show error

    try {
        let json = JSON.parse(jqXHR.responseText);
        let errorCode = json["error_code"] || json["error"] || json["code"]
        let message = ''
        if (json["errors"]) {
            // Example format of errors
            // "errors":{"email":["The email must be a valid email address."]}
            if (json["errors"]) {
                const firstKey = Object.keys(json["errors"])[0]
                message = json["errors"][firstKey][0]
            }
        }
        else if (json["message"]) {
            message = json["message"]
        }
        return { errorCode, message, json }
    }
    catch {
        return { errorCode: 0, message: 'Unknown error', json: {} }
    }
}

export var helper = {
    ajaxFails: ajaxFails
}

export const fixDecimal = (str) => {
    return str && parseFloat(str).toFixed(2) || "0.00"
}

export const parseMultilingual = (json) => {
    let str = []
    if (json.en) {
        str.push(json.en)
    }
    if (json.zn) {
        str.push(json.zn)
    }
    if (json.ms) {
        str.push(json.ms)
    }
    if (json.km) {
        str.push(json.km)
    }
    return str.join(" / ")
}
export const nl2br = (text) => {
    return text.replace('\\n', '\n').split('\n').map(function (item, key) {
        return (
            <span key={key}>
                {item}
                <br />
            </span>
        )
    })
}

/**
 * Parse the given as boolean, return defaultValue if value is undefined or null
 * @param {Boolean} value
 * @param {Boolean} defaultValue
 * @returns
 */
export const parseBoolean = (value, defaultValue) => {
    const isUndefinedOrNull = typeof value === 'undefined' || value === null
    return isUndefinedOrNull ? defaultValue : !!value
}

// https://stackoverflow.com/a/6491621
export const byString = function (o, s) {
    s = (""+s).replace(/\[(\w+)\]/g, '.$1') // convert indexes to properties
    s = s.replace(/^\./, '')           // strip a leading dot
    var a = s.split('.')
    for (var i = 0, n = a.length; i < n; ++i) {
        var k = a[i];
        if (k in o) {
            o = o[k];

            if (!o) {
                return null
            }
        } else {
            return null
        }
    }
    return o
}

export const removeKeyPressListener = (component) => {
    if (component.keyPressListeners) {
        if (component.keyPressListeners.enterKeyListener) {
            $(document).unbind('keypress', component.keyPressListeners.enterKeyListener)
        }
        if (component.keyPressListeners.escListener) {
            $(document).unbind('keyup', component.keyPressListeners.escListener)
        }
    }
}

/**
 * Call this in componetDidMount to disable enter key to submit form.
 * At componentWillUnmount, call 'removeKeyPressListener()' to remove all the
 * key listeners
 * @param {React.Component} component
 */
export const disableEnterKeyToSubmitForm = (component) => {
    if (!component.keyPressListeners) {
        component.unmounted = false
        component.keyPressListeners = {}
    }
    component.keyPressListeners.enterKeyListener = (event) => {
        var keycode = (event.keyCode ? event.keyCode : event.which);
        if (keycode == '13') {
            event.preventDefault();
        }
    }
    $(document).keypress(component.keyPressListeners.enterKeyListener);
}

/**
 * Call this in componetDidMount to enable ECS to close modal (if this.props.onClose is supplied)
 * @param {React.Component} component
 */
export const escKeyToCloseForm = (component) => {
    if (!component.keyPressListeners) {
        component.unmounted = false
        component.keyPressListeners = {}
    }
    component.keyPressListeners.escListener = (event) => {
        var keycode = (event.keyCode ? event.keyCode : event.which);
        if (keycode == '27' && !component.unmounted) {
            component.props.onClose && component.props.onClose()
        }
    }
    $(document).keyup(component.keyPressListeners.escListener);
}

// https://stackoverflow.com/questions/38277385/design-pattern-to-check-if-a-javascript-object-has-changed
// intended to compare objects of identical shape; ideally static.
//
// any top-level key with a primitive value which exists in `previous` but not
// in `current` returns `undefined` while vice versa yields a diff.
//
// in general, the input type determines the output type. that is if `previous`
// and `current` are objects then an object is returned. if arrays then an array
// is returned, etc.
export const getChanges = (previous, current, showDiff) => {
    if (isPrimitive(previous) && isPrimitive(current)) {
        if (previous === current) {
            return ""
        }
        return current
    }

    if (isObject(previous) && isObject(current)) {
        const diff = getChanges(Object.entries(previous), Object.entries(current));
        return diff.reduce((merged, [key, value]) => {
            merged[key] = value
            return merged
        }, {})
    }

    const changes = [];
    if (JSON.stringify(previous) === JSON.stringify(current)) {
        return changes
    }
    for (let i = 0; i < current.length; i++) {
        const item = current[i]
        if (JSON.stringify(item) !== JSON.stringify(previous[i])) {
            if (showDiff) {
                console.log(JSON.stringify(item))
                console.log(JSON.stringify(previous[i]))
            }
            changes.push(item)
        }
    }
    return changes
}

// not required for this example but aid readability of the main function
const typeOf = o => Object.prototype.toString.call(o);
const isObject = o => o !== null && !Array.isArray(o) && typeOf(o).split(" ")[1].slice(0, -1) === "Object";

export const isPrimitive = o => {
    switch (typeof o) {
        case "object":
            return false
        case "function":
            return false
        default:
            return true
    }
}